module.exports = __webpack_public_path__ + "images/emoji/bicyclist.d2586130922aa1753b30.png";